<ng-template #template let-row="row">
  <div *ngIf="row?.externalInvoiceId" class="flex--column">
    {{ row.externalInvoiceId }}
    <div *ngIf="row?.returnInformation?.invoiceDate" class="text--label">{{ row.returnInformation?.invoiceDate | agrDate: 'shortDate' }}</div>
  </div>
</ng-template>
